import * as types from '../constants/lookup'

const initialState = {
  Status: null,
  apiResult: null,
  lookupList: null,
  apiVersionInfo: null
}

export function getAddUserRoleLookup(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_LOOKUP_REQUEST:
      return {
        ...state,
        Status: true,
        lookupList: null
      };
    case types.FETCH_LOOKUP_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiResult: true,
        lookupList: action.data,
      };
    case types.FETCH_LOOKUP_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiResult: false,
        lookupList: action.error
      };
    case types.FETCH_VERSION_LOOKUP_REQUEST:
      return {
        ...state,
        Status: true,
        apiVersionInfo: null
      };
    case types.FETCH_VERSION_LOOKUP_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiResult: true,
        apiVersionInfo: action.apiVersionInfo
      };
    case types.FETCH_VERSION_LOOKUP_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiResult: false,
        apiVersionInfo: action.error
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/lookup.js